import { Box, Flex, Text, Button, Link } from "@chakra-ui/react";
import { ExternalLinkIcon } from "@chakra-ui/icons";
import { Block } from "./MainBlocks/Block";

export const Head06 = ({
  id,
  side,
  fam,
  size,
  height,
  spacing,
  weight,
  settings,
}) => {
  return (
    <Block id={id} sidebar={side}>
      {/* <Box mb="16px">
        <CustomScroll> */}
      <Text
        width={{ base: "2000px", md: "100%", lg: "100%" }}
        // maxHeight="500px"
        // minH="100%"
        style={{ transition: "all .3s ease" }}
        fontFamily={fam}
        fontSize={size}
        lineHeight={`${height}px`}
        letterSpacing={`${spacing}px`}
        fontWeight={weight}
        mb="16px"
      >
        Est auctor est pellentesque placerat convallis. Nunc platea ante elit
        tincidunt arcu dictum semper feugiat. Neque morbi elementum sed donec
        adipiscing eu ultrices pretium. Nunc quis sed lectus consectetur
        fermentum mauris integer. Euismod et sed tempus dictum erat. Nibh netus
        nam sed hendrerit et. Pulvinar sodales volutpat ut ipsum, imperdiet.
        Euismod sollicitudin egestas vitae tristique. In quisque suscipit sit
        urna venenatis mauris. Tempus id faucibus euismod.
      </Text>
      <hr style={{ width: "85%" }} />
      {/* DEFAULT LINK */}
      <Flex
        mb="30px"
        mt="30px"
        alignItems="center"
        // Font variables
        fontFamily={fam}
        fontSize={size}
        lineHeight={`${height}px`}
        letterSpacing={`${spacing}px`}
        fontWeight={weight}
      >
        <Box mr={["30px"]}>
          <Text mb="2px">Home</Text>
          <hr style={{ width: "70%" }} />
        </Box>
        <Box mr={["30px"]}>
          <Text mb="2px">About Us</Text>
          <hr style={{ width: "70%" }} />
        </Box>
        <Box mr={["30px"]}>
          <Text mb="2px">Contact Us</Text>
          <hr style={{ width: "70%" }} />
        </Box>
      </Flex>
      <hr style={{ width: "85%" }} />
      {/* DEFAULT LINK */}
      <Flex
        mb="30px"
        mt="30px"
        alignItems="center"
        // Font variables
        fontFamily={fam}
        fontSize={size}
        lineHeight={`${height}px`}
        letterSpacing={`${spacing}px`}
        fontWeight={weight}
      >
        <Box mr={["30px"]}>
          <Link color="blue" href="#">
            Default Link
          </Link>
        </Box>
        <Box mr={["30px"]}>
          <Link color="blue" href="https://ashfaqkabir.com" isExternal>
            Ashfaq Kabir <ExternalLinkIcon mx="2px" />
          </Link>
        </Box>
      </Flex>
      <hr style={{ width: "85%" }} />

      {/* FIXME: Fix THE HOVER COLOR OF BUTTONS */}
      {/* BUTTON TEXT */}
      <Flex mb="30px" mt="30px" alignItems="center">
        <Box mr={["30px"]}>
          <Button
            minWidth={["138px"]}
            height={["50px"]}
            px={["15px"]}
            py={["10px"]}
            border="1px solid #131215"
            colorScheme={"white"}
            color={"#131215"}
            // bg="#FFF"
            // Font variables

            fontFamily={fam}
            fontSize={size}
            lineHeight={`${height}px`}
            letterSpacing={`${spacing}px`}
            fontWeight={weight}
          >
            Button
          </Button>
        </Box>
        <Box mr={["30px"]}>
          <Button
            minWidth={["138px"]}
            height={["50px"]}
            px={["15px"]}
            py={["10px"]}
            colorScheme={"#272D37"}
            bg={"#272D37"}
            color={"#fff"}
            // bg="#FFF"

            // Font variables
            fontFamily={fam}
            fontSize={size}
            lineHeight={`${height}px`}
            letterSpacing={`${spacing}px`}
            fontWeight={weight}
          >
            Button
          </Button>
        </Box>
        <Box mr={["30px"]}></Box>
      </Flex>
      <hr style={{ width: "85%" }} />
      {/* Settings Block */}
      {settings}
    </Block>
  );
};
